import React from 'react';

import {
  Checkbox, Skeleton, Stack,
} from '@mui/material';

import ContentCard from '../../../../../components/ContentCard';
import StaffGroupChip from '../../../../../components/StaffGroupChip';
import { useUpdateStaffMutation } from '../../../../../services/staff';
import { Staff } from '../../../../../services/staff/types';
import { Metadata } from '../../../../../services/types';
import useError from '../../../../../utils/react/hooks/useError';

interface RolesCardProps {
  staff?: Staff,
  metadata?: Metadata
}

const RolesCard = ({ staff, metadata }: RolesCardProps) => {
  const [updateStaff,
    { isLoading: isStaffUpdateLoading,
      isError: isStaffUpdateError,
      error: staffUpdateError }] = useUpdateStaffMutation();

  useError(isStaffUpdateError, staffUpdateError);

  const addRole = (role: string) => {
    if (staff?.id && staff?.groups) {
      updateStaff({
        staffId: staff.id,
        newAttributes: {
          groups: [...staff.groups, role],
        },
      });
    }
  };

  const removeRole = (role: string) => {
    if (staff?.id && staff?.groups) {
      updateStaff({
        staffId: staff.id,
        newAttributes: {
          groups: staff.groups.filter((group) => group !== role),
        },
      });
    }
  };

  if (!staff) {
    return (
      <Skeleton variant="rectangular" height={128} />
    );
  }

  return (
    <ContentCard variant="contained" title="Roles">
      <Stack direction="column">
        {(metadata?.groups.typeOptions || [])?.map((group) => (
          <Stack key={group.value} direction="row" spacing={2} alignItems="center">
            <Checkbox
              color="darkPrimary"
              disabled={isStaffUpdateLoading}
              checked={staff.groups?.includes(group.value)}
              onChange={(event) => {
                if (event.target.checked) {
                  addRole(group.value);
                } else {
                  removeRole(group.value);
                }
              }}
            />
            <StaffGroupChip
              key={group.value}
              group={group.value}
              size="small"
            />
          </Stack>
        ))}
      </Stack>
    </ContentCard>
  );
};

export default RolesCard;
